//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'leon-alert',
  data () {
    return {
      isShow: true,  // 控制显示隐藏
      timer: null
    }
  },
  mounted () {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonAlert/src/main.vue